import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import adminApiClient from '@/services/adminApiClient';

export function useAdminAuth() {
  const { token, admin, setAuth, clearAuth } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate('/login');
      return;
    }
    if (!admin) {
      adminApiClient.get('/me')
        .then((res) => setAuth(token, res.data))
        .catch(() => {
          clearAuth();
          navigate('/login');
        });
    }
  }, [token]);

  return { token, admin, clearAuth };
}
